import dayjs from 'dayjs';
import { SelectDataProperties } from '../../shared/uiComponents/Dropdown';

export enum Periods {
	'day',
	'week',
	'month',
	'year',
}

export enum LabelPeriods {
	'Date',
	'Week beginning',
	'Month',
	'Year',
}

export enum LabelPeriodsYFrequency {
	'Daily Frequency',
	'Weekly Frequency',
	'Monthly Frequency',
	'Yearly Frequency',
}

export const GRAPH_CONSTANTS = {
	DEFAULT_INTERVAL: '3M',
	DEFAULT_SELECT_VALUE: '0',
	MIN_INSTRUCTION_LENGTH: 4,
	MAX_INSTRUCTION_LENGTH: 250,
	DATE_FORMAT: 'MM/DD/YYYY',
	DATE_FORMAT_DISPLAY: 'MM-DD-YYYY',
	DATETIME_FORMAT: 'YYYY-MM-DD',
	PDF_DATETIME_FORMAT: 'hh_mm_MM/DD/YYYY',
	SUGGESTED_MIN: 0,
	SUGGESTED_MAX_PERCENTAGE: 100,
	SUGGESTED_MAX_DEFAULT: 5,
	CANVAS_ID: 'stackId',
	CANVAS_HEIGHT: 300,
	CANVAS_WIDTH: 500,
	CHART_BORDER_COLOR: 'rgb(53, 162, 235)',
	CHART_BACKGROUND_COLOR: 'rgba(53, 162, 235, 0.5)',
	AVERAGE_LINE_COLOR: 'red',
	ANNOTATION_LINE_COLOR: 'red',
	ANNOTATION_LINE_WIDTH: 2,
	AVERAGE_LINE_DASH: [5, 5] as [number, number],
} as const;

export const commonOptions: any = {
	plugins: {
		legend: {
			position: 'top',
		},
		title: {
			display: true,
		},
		annotation: {
			annotations: [],
		},
	},
	backgroundColor: 'white',
};

export const whiteBackgroundPlugin = {
	id: 'whiteBackgroundPlugin',
	beforeDraw(chart: any) {
		const { ctx } = chart;
		ctx.save();
		ctx.globalCompositeOperation = 'destination-over';
		ctx.fillStyle = 'white';
		ctx.fillRect(0, 0, chart.width, chart.height);
		ctx.restore();
	},
};

export const selectTimeList: SelectDataProperties[] = [
	{ id: '0', name: 'Daily' },
	{ id: '1', name: 'Weekly' },
	{ id: '2', name: 'Monthly' },
	{ id: '3', name: 'Yearly' },
];

const today = dayjs();

export const intervalData = [
	{ id: '1D', value: today.format(GRAPH_CONSTANTS.DATE_FORMAT) },
	{
		id: '5D',
		value: today.subtract(5, 'day').format(GRAPH_CONSTANTS.DATE_FORMAT),
	},
	{
		id: '14D',
		value: today.subtract(14, 'day').format(GRAPH_CONSTANTS.DATE_FORMAT),
	},
	{
		id: 'MTD',
		value: today.startOf('month').format(GRAPH_CONSTANTS.DATE_FORMAT),
	},
	{
		id: '1M',
		value: today.subtract(1, 'month').format(GRAPH_CONSTANTS.DATE_FORMAT),
	},
	{
		id: '3M',
		value: today.subtract(3, 'month').format(GRAPH_CONSTANTS.DATE_FORMAT),
	},
	{
		id: '6M',
		value: today.subtract(6, 'month').format(GRAPH_CONSTANTS.DATE_FORMAT),
	},
	{
		id: 'YTD',
		value: today.startOf('year').format(GRAPH_CONSTANTS.DATE_FORMAT),
	},
	{
		id: '1Y',
		value: today.subtract(1, 'year').format(GRAPH_CONSTANTS.DATE_FORMAT),
	},
	{
		id: '2Y',
		value: today.subtract(2, 'year').format(GRAPH_CONSTANTS.DATE_FORMAT),
	},
	{
		id: '5Y',
		value: today.subtract(5, 'year').format(GRAPH_CONSTANTS.DATE_FORMAT),
	},
];

export const DEFAULT_SCALE_X = {
	type: 'time' as const,
	time: {
		unit: 'day' as const,
		tooltipFormat: 'PP',
	},
	title: {
		display: true,
		text: 'Date',
	},
};
